import React from 'react';
import { Box } from '@mui/material';
import { AU, BORDE_AZUL, CONTORNO_FOCO, FUENTE, OCULTO_VISUAL, RADIO_TARJETA } from '../../styles/tokensAU';
import PildoraAU from './PildoraAU';

// Opción de pago como tarjeta grande seleccionable. Es un radio de verdad (oculto visualmente): el
// teclado y los lectores de pantalla funcionan igual que con un grupo de radios normal.
const OpcionDePago = ({ valor, seleccionado, onSeleccionar, titulo, detalle, recomendado = false }) => (
  <Box
    component="label"
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1.5,
      minHeight: 72,
      p: 2,
      cursor: 'pointer',
      borderRadius: RADIO_TARJETA,
      // Borde de 2 px en las dos (transparente en la no elegida): mismo ancho y nada salta al cambiar.
      border: `2px solid ${seleccionado ? AU.azulHover : 'transparent'}`,
      transition: 'background-color 120ms, border-color 120ms',
      '&:hover': seleccionado ? {} : { borderColor: BORDE_AZUL },
      // Seleccionada se rellena de AU Blue oscuro (texto blanco, 5,23:1); la otra queda azul suave.
      bgcolor: seleccionado ? AU.azulHover : AU.azulSuave,
      // Solo con foco de teclado: focus-within también mostraba el contorno al hacer clic con el mouse.
      '&:has(input:focus-visible)': { ...CONTORNO_FOCO },
      // Navegadores sin :has() (Firefox anterior a la 121): sin esto la tarjeta no mostraría el foco de teclado.
      '@supports not selector(:has(*))': { '&:focus-within': { ...CONTORNO_FOCO } },
    }}
  >
    <Box
      component="input"
      type="radio"
      name="metodoPago"
      value={valor}
      checked={seleccionado}
      onChange={() => onSeleccionar(valor)}
      sx={OCULTO_VISUAL}
    />
    <Box
      aria-hidden="true"
      sx={{
        width: 20,
        height: 20,
        mt: '2px',
        flexShrink: 0,
        borderRadius: '50%',
        border: `2px solid ${seleccionado ? AU.blanco : AU.azulHover}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {seleccionado && <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: AU.blanco }} />}
    </Box>
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Box component="span" sx={{ fontFamily: FUENTE, fontSize: 16, fontWeight: 700, color: seleccionado ? AU.blanco : AU.oscuro }}>{titulo}</Box>
        {/* La tarjeta es azul (suave o rellena): la píldora va siempre en blanco para no perderse. */}
        {recomendado && (
          <PildoraAU sx={{ textTransform: 'uppercase', letterSpacing: '0.04em', bgcolor: AU.blanco }}>
            Recomendado
          </PildoraAU>
        )}
      </Box>
      {/* Gris medio sobre azul suave da 4,26:1 (<4,5): el detalle va en oscuro, o azul suave sobre la tarjeta rellena (4,73:1). */}
      <Box sx={{ mt: 0.25, fontFamily: FUENTE, fontSize: 14, color: seleccionado ? AU.azulSuave : AU.oscuro }}>{detalle}</Box>
    </Box>
  </Box>
);

export default OpcionDePago;
